import axios from "axios";
// Entities
import { StockRealVsPrev } from "@/entities/index";

export async function getRealStockVSPrev({
  client,
  warehouse,
  integrateStepZero,
}: {
  client: string;
  warehouse: string;
  integrateStepZero: boolean;
}): Promise<{ realStock: number[]; realStockPrev: number[]; month: string[] }> {
  const { realStock, realStockPrev, month } = (
    await axios.post(`/api/dashboards/chart3`, {
      client,
      warehouse,
      integrateStepZero,
    })
  ).data as StockRealVsPrev;

  return { realStock, realStockPrev, month };
}
